export default __webpack_public_path__ + "static/media/object--sign--store.6da73474.png";